<script>
import Layout from "../../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "../../../../../app.config";
import CopassMayor10 from "@/components/standard/Copass/ConformacionCopass.Mayor10";


/**
 * Form elements component
 */
export default {
  page: {
    title: "1.1.6 Acta de conformación Copasst Vigía de salud",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    CopassMayor10,
  },
  data() {
    return {
      title: "1.1.6 Acta de conformación Copasst Vigía de salud",
      items: [{
        text: 'Estándares',
        href: '/forms/estandares',
      },
      {
        text: '1.1.6 Acta de conformación Copasst Vigía de salud',
        href: `/forms/estandares/${this.$store.getters["company/getCompany"].id}/acta-conformacion1.1.6`
      },
      {
        text: '1.1.6 Registro de Acta de conformación Copasst',
        active: true
      },
      ],
      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
      copasstID: Number(this.$route.params.copasst),
    };
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div>
      <CopassMayor10 :companyID="companyID" :copasstID="copasstID" class="animated animatedFadeInUp fadeInUp" />
    </div>
  </Layout>
</template>
